import {
  ErrorBoundary,
  createEffect,
  createSignal,
  lazy,
  onMount,
} from "solid-js";

import { LogoLoading } from "@/components/Base/LogoLoading/LogoLoading.tsx";
import { MetaProviderWrapper } from "@/components/Base/MetaContainer";
import { isMobile } from "@/lib/isMobile.ts";
import { Router } from "@solidjs/router";

import "./app.css";
import { usePreventZoom } from "./hooks/usePreventZoom.ts";
import { initPwaState } from "./lib/pwa.ts";
import { renderRoutes } from "./router";

const ErrorPage = lazy(() => import("./pages/error.tsx"));

export default function App() {
  const [isReady, setIsReady] = createSignal(false);

  usePreventZoom(); // 防止移动端缩放/双击放大/双指手势放大/长按菜单

  createEffect(() => {
    console.log("📱 isMobile:", isMobile());
    document.body.setAttribute("data-device", isMobile() ? "mobile" : "pc");
  });

  onMount(() => {
    (async () => {
      try {
        // 先初始化 PWA
        initPwaState();

        // 标记应用准备就绪
        setIsReady(true);
      } catch (error) {
        console.error("❌ init app error:", error);
        // 即使初始化失败，也标记为准备就绪，避免无限加载
        setIsReady(true);
      }
    })();
  });
  return (
    <>
      <LogoLoading />
      <ErrorBoundary fallback={(err) => <ErrorPage type={"error"} err={err} />}>
        <MetaProviderWrapper>
          <Router>{renderRoutes()}</Router>
        </MetaProviderWrapper>
      </ErrorBoundary>
    </>
  );
}
